<template>
  <div id="scroll-board" @click="routerFtqTop()">
    <div class="title">
      {{ title
      }}<dv-decoration-3 style="width:4rem; height: 30px; right: 50px; position: absolute" />
    </div>
    <dv-decoration-10 style="width: 300px; height: 5px" />
    <dv-scroll-board :config="config" />
  </div>
</template>

<script>
import dateFormat from "date-fns/format";
export default {
  name: "scrollFTQ",
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.datas = val;
        this.createData();
      },
      deep: true,
    },
    title: {
      handler: function (val, oldVal) {
        this.title = val;
      },
      deep: true,
    },
  },
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
    title: {
      type: String,
      default: function () {
        return "上周影响主要问题";
      },
    },
  },
  data() {
    return {
      datas: this.beans,
      config: {
        // header: ["产线", "发生时间", "状态", "数量"],
        // data: [],
        // columnWidth: [100, 100, 130, 100],
        // align: ["center"],
        // rowNum: 3,
        // headerBGC: "rgba(10, 29, 50, 0.8)",
        // headerHeight: 30,
        // oddRowBGC: "rgba(0, 44, 81, 0.8)",
        // evenRowBGC: "rgba(10, 29, 50, 0.8)",
      },
    };
  },
  methods: {
    routerFtqTop() {
      this.$router.push({
        path: "/oee/ftq-top"
      });
    },
    createData() {
      var dataList = this.datas;
      var data = [];
      for (var i = 0; i < dataList.length; i++) {
        var line = dataList[i]["line"];
        var device = dataList[i]["device"];
        var faiCode = dataList[i]["faiCode"];
        var faiCause = dataList[i]["faiCause"];
        var productName = dataList[i]["productName"];
        var quantity = dataList[i]["quantity"];

        line = '<span style="color:#00E690">' + line + "</span>";
        device = '<span style="color:#00E690">' + device + "</span>";
        productName = '<span style="color:#00E690">' + productName + "</span>";
        faiCause = '<span style="color:#00E690">' + faiCause + "</span>";
        quantity = '<span style="color:#00E690">' + quantity + "</span>";


        var value = [line, device, productName, faiCause, quantity];
        data.push(value);
      }

      this.config = {
        header: ["产线", "设备", "产品", "不良描述", "数量(个)"],
        data: data,
        columnWidth: [130, 180, 150, 250, 120],
        align: ["left", "left", "left", "left", "center"],
        rowNum: 6,
        headerBGC: "rgba(6, 30, 93, 0.5)",
        headerHeight: 30,
        oddRowBGC: "rgba(0, 44, 81, 0.8)",
        evenRowBGC: "rgba(10, 29, 50, 0.8)",
      };
    },
    dateFormat(uninx) {
      return dateFormat(uninx, "MM-dd");
    },
  },
};
</script>

<style lang="less">
#scroll-board {
  width: 100%;
  box-sizing: border-box;
  margin-left: 10px;
  height: 50%;
  overflow: hidden;

  // margin-bottom:2%;
  .title {
    height: 30px;
    margin-bottom: 0px;
    font-weight: bold;
    text-indent: 20px;
    font-size: 20px;
    text-align: center;
    display: flex;
    align-items: center;
  }

  .header-item {
    font-weight: bold;
    font-size: 17px;
    text-shadow: 0 0 10px #fff,
      0 0 25px #33ccff,
  }

  .row-item {
    font-weight: bold;
    font-size: 15px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/oee/component/scrollFTQ.vue